import React, { useState } from "react";
import { toast } from "react-toastify";
import "./transfer.scss";

const formatDate = (date) => {
    const day = ("0" + date.getDate()).slice(-2);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
};

const getAccreditedDate = (selectedDateStr) => {
    const now = new Date();
    const selectedDate = new Date(selectedDateStr);
    const isToday = now.toDateString() === selectedDate.toDateString();

    let workingDaysToAdd = 2;

    if (isToday && now.getHours() >= 12) {
        workingDaysToAdd = 3;
    }

    let resultDate = new Date(selectedDate);

    while (workingDaysToAdd > 0) {
        resultDate.setDate(resultDate.getDate() + 1);

        const day = resultDate.getDay();
        if (day !== 0 && day !== 6) {
            workingDaysToAdd--;
        }
    }

    return formatDate(resultDate);
};


const FormStep1 = ({
    setFormStep1SelectedOption,
    handleChange,
    data,
    formStep1SelectedOption
}) => {
    const todayStr = new Date().toISOString().split("T")[0];
    const [clicked, setClicked] = useState(false)

    const options = [
        {
            key: "ORDINARY",
            title: "ORDINARY",
            subtitle: "Choose the date...",
            commission: "0,00 EUR",
            revocable: "Revocable until 23:59 of the day before execution",
            disabled: false,
        },
        {
            key: "URGENT",
            title: "URGENT",
            subtitle: "I'm in a hurry.",
            note: "Available only on request and until 17:30 on working days.",
            commission: "0,00 EUR",
            disabled: true,
        },
        {
            key: "INSTANT",
            title: "INSTANT",
            subtitle: "I'm in a big rush!",
            dateExecution: new Date().toISOString().split("T")[0],
            dateAccredited: "10 SECONDS",
            commission: "0,00 EUR",
            revocable: "Not revocable",
            disabled: true,
        },
    ];

    const onSelect = (key) => {
        handleChange({ target: { name: "priority", value: true } });
        setFormStep1SelectedOption(key);
        setClicked(true)
    };

    const getEarliestValidDate = () => {
        const now = new Date();
        let date = new Date();

        if (now.getHours() >= 12) {
            date.setDate(date.getDate() + 1);
        }

        while (date.getDay() === 0 || date.getDay() === 6) {
            date.setDate(date.getDate() + 1);
        }

        return date.toISOString().split("T")[0];
    };

    const handleExecutionDateChange = (e) => {
        const value = e.target.value;
        const selectedDate = new Date(value);

        const earliestStr = getEarliestValidDate();
        const earliestDate = new Date(earliestStr);
        const day = selectedDate.getDay();

        if (day === 0 || day === 6) {
            toast.warning('Payments are processed on business days only. Please select a weekday.');
            return;
        }

        if (selectedDate < earliestDate) {
            toast.warning(`Please select a date starting from ${earliestStr}.`);
            return;
        }

        handleChange(e);
    };

    return (
        <div className="container my-5">
            <p className="mb-4 text-muted">Select <strong>Execution Date</strong> then click <strong>Select</strong> on the transfer type.</p>
            <div className="row">
                {options.map((opt) => (
                    <div className="col-md-4 mb-3" key={opt.key}>
                        <div className={`card h-100 ${formStep1SelectedOption === opt.key ? "shadow-lg border-primary" : "shadow-sm"}`}>
                            <div className="card-body">

                                <div className="row mb-2">
                                    <div className="col-md-3 mt-1">
                                        <i
                                            className={`fa-solid ${opt.key === "ORDINARY"
                                                ? "fa-hourglass"
                                                : opt.key === "URGENT"
                                                    ? "fa-bolt"
                                                    : "fa-rocket"
                                                } fa-3x
                                                ${formStep1SelectedOption === opt.key ? "unicol" : "text-muted"}`}
                                        />
                                    </div>
                                    <div className="col-md-9">
                                        <h5 className="card-title d-flex align-items-center gap-2">
                                            {opt.title}
                                        </h5>
                                        <p className="text-muted">{opt.subtitle}</p>
                                    </div>
                                </div>

                                <div className="w-100 border-bottom mb-3"></div>

                                {opt.key === "ORDINARY" && (
                                    <div className="row mb-2">
                                        <div className="col-md-6 mb-2">
                                            <label className="form-label fw-semibold">Execution date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="execution_date"
                                                min={getEarliestValidDate()}
                                                value={data?.execution_date || ""}
                                                onChange={handleExecutionDateChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            {data?.execution_date && (
                                                <>
                                                    <label className="form-label fw-semibold">Accreditation date</label>
                                                    <div className="input-group">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={getAccreditedDate(data.execution_date)}
                                                            disabled
                                                        />
                                                        <span className="input-group-text bg-light">
                                                            <i className="fa-regular fa-calendar-days"></i>
                                                        </span>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {opt.dateExecution && opt.dateAccredited && opt.key !== "ORDINARY" && (
                                    <div className="row mb-2">
                                        <div className="col-md-6 mb-2">
                                            <label className="form-label fw-semibold">Execution date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="execution_date"
                                                min={todayStr}
                                                value={opt.dateExecution}
                                                disabledF
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Accreditation date</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={opt.dateAccredited}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {opt.note && <p className="small text-muted" style={{ marginTop: "40px" }}>{opt.note}</p>}

                                <div className="row mt-2">
                                    <div className="col-md-12 m-0">
                                        <p>
                                            Tot. commission*
                                        </p>
                                    </div>
                                    <div className="col-md-12 m-0">
                                        <p>
                                            <strong> {opt.commission}</strong>
                                        </p>
                                    </div>
                                </div>

                                {opt.revocable && (
                                    <p className="small text-muted">({opt.revocable})</p>
                                )}

                            </div>
                            <div className="card-body p-0 m-0 d-flex flex-column justify-content-between">
                                <button
                                    className={`btn btn-dark w-100 mt-auto rounded-0 ${(opt.key === "ORDINARY" && data?.execution_date && !clicked) && "pulse-css-select"}`}
                                    onClick={() => onSelect(opt.key)}
                                    disabled={opt.disabled || (opt.key === "ORDINARY" && !data?.execution_date)}
                                >
                                    SELECT
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FormStep1;
